module.exports = __webpack_public_path__ + "media/images/favicon-32-9badbd1311e8f990164e3501b1eeaa78.png";